
<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main" class="tabWrap">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div class="container">
                            <div class="titleBox">
                                <div>申请信息：</div>
                                <div class="titleNum">编号：{{serialNumber}}</div>
                            </div>
                        </div>
                        <el-table
                                ref="dataTable"
                                :data="invoiceList"
                                highlight-current-row
                                size="mini"
                                height="100%"
                                border
                        >
                            <el-table-column
                                    prop="deptName"
                                    label="项目部"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="projectName"
                                    label="项目名称"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="subContractName"
                                    label="分项合同名称"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="subContractSerial"
                                    label="分项合同编码"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billHead"
                                    label="发票抬头"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="taxPayerCode"
                                    label="纳税人识别号"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billCode"
                                    label="发票代码"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billNumber"
                                    label="发票号码"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="amountWithoutTax"
                                    label="不含税金额（元）"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    width="100px"
                                    prop="tax"
                                    label="税额（元）"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    width="100px"
                                    prop="taxRateShow"
                                    label="税率（%）"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    width="120px"
                                    prop="amount"
                                    label="发票金额（元）"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billUsageShow"
                                    label="发票用途"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billTypeShow"
                                    label="发票类型"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billInvoiceTypeShow"
                                    label="发票种类"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="createUserName"
                                    label="提交人"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="createTime"
                                    label="提交时间"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="审批流程" name="Tab2" style="min-height: 500px;">
                      <div v-if="approveFlag === 'currentApprove'|| approveFlag=== 'commonMessage'">
                        <approveItem
                            :itemId="contractId"
                            :approveType="approveType"
                            :subapproveType="subapproveType"
                            @finishApprove="reset()"
                        >
                        </approveItem>
                      </div>
                      <div v-else>
                        <approveLine
                            :itemId="contractId"
                            :approveType="approveType"
                        ></approveLine>
                      </div>
                    </el-tab-pane>
                </el-tabs>
            </el-main>
            <el-footer class="containerBox">
                <div class="btnMid">
                    <el-button type="info" @click="reset()">关 闭</el-button>
                </div>
            </el-footer>
        </el-container>

    </div>
</template>

<script>
    import {
        getIncomeApproveDetailService,
    } from '@/services/invoiceServices'
    import approveLine from "@/page/approveComponents/ApproveHistoryLine";
    import approveItem from "@/page/approveComponents/ApproveItem"; //审批流程
    import {goBackApprove} from '@/page/approveComponents/approve';

    export default {
        name: "approve-details",
        data(){
            return {
                approveId:'',
                serialNumber:'',
                invoiceList:[],
                total:0,
                dataForm:{
                    pageIndex: 1,
                    pageSize: 10,
                },
                activeName: 'Tab1',
                editableTabs: [{
                    label: '基本信息',
                    name: 'Tab1'
                }, {
                    label: '审批流程',
                    name: 'Tab2'
                }],

                approveFlag: '', //审批状态
                approveType: "INPUT_BILL_APPROVE", //审批类型
                subapproveType: '',
                contractId: 0,
            }
        },
        components:{
          approveLine, //审批历史流程
          approveItem, //审批
        },
        methods:{
            onActive(menuCode) {
                this.approveId = this.tabRouteParam.id;
                this.getApproveDetail();

              this.approveFlag = this.tabRouteParam
                  ? this.tabRouteParam.approveFlag
                  : "";
              this.contractId = Number(this.tabRouteParam.id);
            },
            /***
             * 获取审批详情列表
             */
            getApproveDetail(){
                let params = {
                    id: this.approveId
                }
                getIncomeApproveDetailService(params).then( res => {
                    if(res.code == 10000000){
                        this.invoiceList = res.data.inputBillListVOList;
                        this.serialNumber = res.data.serialNumber;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(tab)
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
            reset(){
                if(this.approveFlag){
                  goBackApprove(this.approveFlag,'approveDetails')
                }else{
                  this.bus.$emit("tabClose", "approveDetails");
                  this.bus.$emit("navMenuChange", {
                    routeId: "reimbursement"
                  });
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .tabWrap {
        height: calc(100% - 60px);

        /deep/ .el-tabs--top {
          height: 100%;
          overflow: hidden;

          .el-tabs__content {
            height: calc(100% - 140px);
            padding: 0 20px 20px;
            overflow: auto;

            .el-form-item {
              width: 100%;
            }

            .el-checkbox {
              line-height: 40px;
            }

            .el-textarea {
              min-width: 0px !important;
            }
            .el-cascader {
              width: 100%;
            }

            .el-form-item__content {
              width: calc(100% - 150px);

              .el-input {
                width: 100%;
              }
            }
          }
        }
      }
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .containerBox {
      width: 100%;
      height: 36px !important;
      position: fixed;
      bottom: 44px;
      left: 0;
      text-align: start;
    }
    .btnMid {
      position: relative;
      left: 27%;
      bottom: 0px;
      display: flex;
    }
    /deep/.ApproveItem .bottomBtn{
      bottom: 44px;
      z-index: 10;
    }
    /deep/.el-tabs__item{
        padding: 0 20px !important;
    }
</style>
